/* แถบทางลัดลอยกลางล่างจอ (ทุกขนาดจอ, เฉพาะสมาชิก) — ปุ่มกลาง "ทางเข้า" นูนขึ้นมา
   ไอคอนเส้นชุดเดียวกับเมนูสมาชิก (LineIcon) · ปุ่ม "อื่นๆ" เปิดแผงเมนูทั้งหมด (QbarMore) */
import nextDynamic from 'next/dynamic';
import LineIcon from './LineIcon';

// staticAuth (เช่นทุกหน้า /articles/*) ไม่เรนเดอร์ตัวนี้เลย — โหลดแบบแยกชิ้นกันมัดรวม
// เข้า bundle ของหน้าที่ไม่ได้ใช้ (ใช้ lib/auth, lib/toast, lib/gameNavigation ร่วมกับ AuthWidget)
const QbarEnter = nextDynamic(() => import('./QbarEnter'));
const QbarMore = nextDynamic(() => import('./QbarMore'));

export default function FooterQuick({ staticAuth = false }) {
  return (
    <nav className="qbar" aria-label="ทางลัด">
      <a href="/wallet?tab=deposit"><i><LineIcon name="deposit" /></i><span>ฝากเงิน</span></a>
      <a href="/wallet?tab=withdraw"><i><LineIcon name="withdraw" /></i><span>ถอนเงิน</span></a>
      {staticAuth
        ? <a className="qbar-main" href="/?auth=login"><i><LineIcon name="play" size={26} /></i><span>ทางเข้า</span></a>
        : <QbarEnter><i><LineIcon name="play" size={26} /></i><span>ทางเข้า</span></QbarEnter>}
      <a href="/promotions"><i><LineIcon name="gift" /></i><span>โปรโมชั่น</span></a>
      {/* แถบนี้แสดงเฉพาะสมาชิก — "อื่นๆ" เปิดแผงเมนูทั้งหมดของตัวเอง (ติดต่อเราอยู่ในแผงนั้น) ใช้ได้ทุกหน้า */}
      <QbarMore><i><LineIcon name="more" /></i><span>อื่นๆ</span></QbarMore>
    </nav>
  );
}
